import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { STEPS } from "../../data/site";

export const Metodo = () => (
  <section data-testid="metodo-section" className="py-20 lg:py-32 bg-graphite border-y border-steel">
    <div className="max-w-7xl mx-auto px-5 lg:px-10">
      <SectionHeading
        number="05"
        overline="Metodo di lavoro"
        lines={["Come lavoriamo"]}
        description="Un percorso chiaro in quattro passaggi: dal primo sopralluogo alla consegna del lavoro finito."
      />
      <div className="mt-12 lg:mt-16 grid gap-10 lg:grid-cols-4 lg:gap-0">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.1}>
            <div
              data-testid={`metodo-step-${s.num}`}
              className="relative lg:px-8 lg:first:pl-0 lg:last:pr-0 pl-10 lg:pl-8 border-l lg:border-l-0 lg:border-t border-steel py-1 lg:pt-8 lg:pb-0"
            >
              <span className="absolute -left-[5px] lg:left-8 lg:-top-[5px] lg:first:left-0 w-2.5 h-2.5 bg-forest-glow rotate-45" aria-hidden="true" />
              <p className="font-display font-bold text-4xl lg:text-5xl text-steel" aria-hidden="true">{s.num}</p>
              <h3 className="font-display font-bold text-lg uppercase tracking-tight text-white mt-4">{s.title}</h3>
              <p className="text-sm text-cement leading-relaxed mt-2.5 max-w-xs">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
